import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type Themes = "light" | "dark";

type InitialState = {
  menuOpen: boolean;
  theme: Themes;
};

const initialState: InitialState = {
  menuOpen: false,
  theme: "light",
};

const ui = createSlice({
  name: "ui",
  initialState,
  reducers: {
    resetUiStore: () => initialState,
    setMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.menuOpen = action.payload;
    },
    setTheme: (state, action: PayloadAction<Themes>) => {
      state.theme = action.payload;
    },
  },
});

export const { resetUiStore, setMenuOpen } = ui.actions;

export default ui.reducer;
